export const SET_ORIGIN = 'SET_ORIGIN';
export const SET_DESTINATION = 'SET_DESTINATION';
export const SET_DATES = 'SET_DATES';
export const SET_ROUND_TRIP = 'SET_ROUND_TRIP';
export const SET_IMAGINE_MODE = 'SET_IMAGINE_MODE';
export const SET_PASSENGERS = 'SET_PASSENGERS';
export const SET_PASSENGER_TYPE = 'SET_PASSENGER_TYPE';
export const SET_PROMO_CODE = 'SET_PROMO_CODE';
export const ADD_COURSE = 'ADD_COURSE';
export const REMOVE_COURSE = 'REMOVE_COURSE';
export const UPDATE_COURSE = 'UPDATE_COURSE';
export const SWITCH_COURSES_INDEXES = 'SWITCH_COURSES_INDEXES';
export const SET_PAX_TYPE_WAS_CHANGED = 'SET_PAX_TYPE_WAS_CHANGED';
export const REFRESH = 'REFRESH';
